import { withContext } from '@tools/wr-catalog-base'
import List from './List'

export default withContext(List)
